(() => {
  if (window.zippoCommercialAttachments) { window.zippoCommercialAttachments(document); return; }
  const mounted = new WeakSet();
  const makeKey = () => {
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = [...bytes].map(value => value.toString(16).padStart(2,'0')).join('');
    return [hex.slice(0,8),hex.slice(8,12),hex.slice(12,16),hex.slice(16,20),hex.slice(20)].join('-');
  };
  function mount(root) {
    if (mounted.has(root)) return;
    mounted.add(root);
    const form = root.closest('form');
    const input = root.querySelector('input[type=file]');
    const picker = root.querySelector('[data-upload-pick]');
    const list = root.querySelector('[data-upload-list]');
    const status = root.querySelector('[data-upload-status]');
    const retry = root.querySelector('[data-upload-retry]');
    const clear = root.querySelector('[data-upload-clear]');
    const reference = root.querySelector('[data-upload-reference]');
    const names = root.querySelector('[data-upload-names]');
    const submit = form.querySelector('[type=submit]');
    const completed = root.dataset.uploadSuccess === 'true' || form.querySelector('[data-zq-context]')?.dataset.zqState === 'success';
    const copy = key => root.dataset['upload' + key[0].toUpperCase() + key.slice(1)];
    const storageKey = 'zippo-attachments:' + location.pathname + ':' + form.id;
    let generation = 0, controller = null, selected = [], group = null;
    root.hidden = false;
    const save = data => sessionStorage.setItem(storageKey, JSON.stringify({...data, time: Date.now()}));
    try { sessionStorage.setItem(storageKey + ':probe','1'); sessionStorage.removeItem(storageKey + ':probe'); }
    catch (_) { input.disabled = picker.disabled = true; status.textContent = copy('storage'); return; }
    picker.addEventListener('click',() => input.click());
    input.addEventListener('invalid',event => {event.preventDefault();status.focus();});
    function state(value, message) {
      root.dataset.uploadState = value;
      status.textContent = message;
      const blocked = value === 'busy' || value === 'error';
      input.setCustomValidity(blocked ? message : '');
      submit.disabled = completed || blocked;
      retry.hidden = value !== 'error' || !selected.length;
      clear.hidden = value === 'empty';
    }
    function render(files) {
      list.replaceChildren();
      for (const file of files) {
        const item = document.createElement('li');
        item.textContent = file.name + ' · ' + ((file.size || 0)/1024/1024).toFixed(2) + ' MB';
        list.append(item);
      }
    }
    function reset() {
      generation++;
      controller?.abort();
      selected = []; group = null;
      input.value = '';
      reference.disabled = names.disabled = true;
      reference.value = names.value = '';
      sessionStorage.removeItem(storageKey);
      render([]);
      state('empty', '');
    }
    async function api(path, body, signal, fileHeaders) {
      const requestController = new AbortController();
      const cancel = () => requestController.abort();
      signal?.addEventListener('abort',cancel,{once:true});
      if (signal?.aborted) requestController.abort();
      const timer = setTimeout(cancel,90000);
      try {
        const response = await fetch(root.dataset.uploadApi + path, {
          method: body ? 'POST' : 'GET', credentials: 'omit', signal: requestController.signal,
          headers: fileHeaders || (body ? {'Content-Type':'application/json'} : {}), body: fileHeaders ? body : body ? JSON.stringify(body) : undefined
        });
        const result = await response.json();
        if (!response.ok) throw new Error(root.dataset.uploadLanguage === 'it' && result.error ? result.error : copy('error'));
        return result;
      } finally { clearTimeout(timer); signal?.removeEventListener('abort',cancel); }
    }
    function ready(result) {
      const expected = [
        'https://mini-pc-zippo.taile4178b.ts.net:10000/allegati-commerciali/#',
        'https://mini-pc-zippo.taile4178b.ts.net:10000/candidature/commerciale/#'
      ].map(base => base + group.id);
      if (!result.ready || result.id !== group.id || !expected.includes(result.link) || !Array.isArray(result.files) || !result.files.length) throw new Error(copy('error'));
      save({...group, ready:true});
      reference.value = result.link;
      names.value = result.files.map(file => file.name).join('\n');
      reference.disabled = names.disabled = false;
      render(result.files);
      input.value = '';
      state('ready',copy('ready'));
    }
    async function upload() {
      const version = ++generation;
      controller?.abort();
      controller = new AbortController();
      const signal = controller.signal;
      const current = () => version === generation;
      state('busy',copy('busy'));
      reference.disabled = names.disabled = true;
      try {
        if (!group) {
          const key = makeKey();
          group = {key};
        }
        if (!group.id) {
          const {challenge} = await api('/challenge',null,signal);
          await new Promise(resolve => setTimeout(resolve,1100));
          if (!current()) return;
          const result = await api('/groups',{key:group.key,challenge,page:root.dataset.uploadPage,language:root.dataset.uploadLanguage},signal);
          if (!current()) return;
          if (!/^AL-[A-F0-9]{24}$/.test(result.id) || !/^[a-f0-9]{64}$/.test(result.token)) throw new Error(copy('error'));
          group = {...group,...result};
          save(group);
        }
        for (const entry of selected) {
          if (!current()) return;
          status.textContent = copy('busy') + ' ' + entry.file.name;
          await api('/groups/'+group.id+'/files',entry.file,signal,{'Content-Type':'application/octet-stream','X-Upload-Token':group.token,'X-Upload-Key':entry.key,'X-Upload-Name':encodeURIComponent(entry.file.name)});
        }
        if (!current()) return;
        const result = await api('/groups/'+group.id+'/seal',{token:group.token},signal);
        if (current()) ready(result);
      } catch (error) {
        if (current()) state('error',error.name === 'AbortError' ? copy('error') : error.message || copy('error'));
      }
    }
    input.addEventListener('change',() => {
      const files = [...input.files];
      generation++; controller?.abort(); group = null;
      sessionStorage.removeItem(storageKey);
      reference.disabled = names.disabled = true;
      if (!files.length) { reset(); return; }
      render(files);
      selected = files.map(file => ({file,key:makeKey()}));
      if (files.length > 3 || files.some(file => !file.size || file.size > 25*1024*1024 || !/\.(pdf|ai|psd|tiff?|jpe?g|png|heic|heif|webp|avif)$/i.test(file.name))) {
        selected = []; state('error',copy('limits')); return;
      }
      upload();
    });
    clear.addEventListener('click',reset);
    retry.addEventListener('click',upload);
    if (completed) { reset(); root.hidden = true; return; }
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (saved && saved.time > Date.now()-2*60*60*1000 && /^AL-[A-F0-9]{24}$/.test(saved.id) && /^[a-f0-9]{64}$/.test(saved.token)) {
        group = saved;
        const version = ++generation;
        controller = new AbortController();
        state('busy',copy('busy'));
        api('/groups/'+group.id+'/status',{token:group.token},controller.signal).then(result => {
          if (version !== generation) return;
          if (!result.ready) throw new Error(copy('error'));
          ready(result);
        }).catch(error => { if (version === generation) state('error',error.message || copy('error')); });
      } else reset();
    } catch (_) { reset(); }
  }
  const scan = root => root.querySelectorAll('[data-zq-attachments]').forEach(mount);
  window.zippoCommercialAttachments = scan;
  scan(document);
  document.addEventListener('shopify:section:load',event => scan(event.target));
})();
